import { useEffect, useState } from "react";
import { db } from "./firebase.js";
import { collection, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";

export default function ExploreEntries() {
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    const fetchEntries = async () => {
      try {
        const snapshot = await getDocs(collection(db, "limericks"));
        const data = snapshot.docs.map(doc => doc.data());
        setEntries(data);
      } catch (error) {
        console.error("Error fetching entries:", error);
      }
    };
    fetchEntries();
  }, []);

  return (
    <div className="container">
    <div style={{ padding: '2rem', margin: '0 auto' }}>
     <Link to="/">Home</Link> | <Link to="/explore"> Archive </Link> | <Link to="/glossary"> Whispered Footnotes </Link> | <Link to="/about">About</Link>

      <h2 style={{ fontSize: '2rem'}}>Archive of whispers</h2>
      <div className="section">
        <p> Each poem here begins with an invitation—but what follows is real answers. Disjointed responses between user input and AI responses show the gap in language when AI is faced with words that are personal and deeply rooted in culture. Together, these limericks archive what language alone can’t hold: memory, nuance, care.</p>
        <p>Read them not as verse, but as testimony. </p>
        <p>
          Remove the first sentence, and the limericks together create a digital
          archive, a ballad of language people are afraid of losing.
        </p>
      </div>
      </div>
      

      {entries.length === 0 ? (
        <p>No entries yet.</p>
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '1.5rem',
            paddingTop: '1rem'
          }}
        >
          {entries.map((entry, i) => (
            <div
              key={i}
              style={{
                backgroundColor: '#121212',
                border: '1px solid #2a2a2a',
                borderRadius: '0.5rem',
                padding: '1rem 1.25rem',
                transition: 'transform 0.2s ease, background-color 0.2s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = '#1e1e1e')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = '#121212')
              }
            >
              {entry.lines.map((line, j) => (
                <p key={j} style={{ margin: '0.25rem 0' }}>
                  {line}
                </p>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
